function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { forwardRef } from "react";
import { Body, Checkbox, ErrorMessage, FieldLabel, Input, Select, Textarea } from "../../atoms";
function RawFormField(_param, ref) {
    var id = _param.id, label = _param.label, name = _param.name, error = _param.error, className = _param.className, helpText = _param.helpText, required = _param.required, props = _objectWithoutProperties(_param, [
        "id",
        "label",
        "name",
        "error",
        "className",
        "helpText",
        "required"
    ]);
    var help = helpText ? /*#__PURE__*/ React.createElement(Body, {
        className: "mt-2 text-fg-inbetween"
    }, helpText) : null;
    if (props.type === "checkbox") {
        return /*#__PURE__*/ React.createElement("fieldset", {
            className: className
        }, /*#__PURE__*/ React.createElement("div", {
            className: "grid gap-3 items-start grid-cols-[auto_1fr]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex h-[1.5em] items-center text-body.small md:text-body.base"
        }, /*#__PURE__*/ React.createElement(Checkbox, _extends({
            id: id,
            ref: ref,
            name: name
        }, props.fieldProps))), /*#__PURE__*/ React.createElement("label", {
            htmlFor: id
        }, /*#__PURE__*/ React.createElement(Body, {
            className: "break-words"
        }, label, required ? /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": "true"
        }, " *") : null))), help, !!error && /*#__PURE__*/ React.createElement(ErrorMessage, {
            className: "mt-3"
        }, error));
    }
    if (props.type === "radio") {
        var _$ref;
        return /*#__PURE__*/ React.createElement("fieldset", {
            className: className
        }, /*#__PURE__*/ React.createElement(FieldLabel, {
            as: "legend",
            id: "".concat(id, "-label")
        }, label, required ? /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": "true"
        }, " *") : null), /*#__PURE__*/ React.createElement("div", {
            className: "grid gap-3"
        }, (_$ref = props.options) === null || _$ref === void 0 ? void 0 : _$ref.map(function(option) {
            return /*#__PURE__*/ React.createElement("div", {
                key: option.value,
                className: "grid gap-3 items-center grid-cols-[auto_1fr]"
            }, /*#__PURE__*/ React.createElement("input", _extends({
                type: "radio",
                id: "".concat(id, "-").concat(option.value),
                ref: ref,
                name: name,
                value: option.value,
                className: "w-4 h-4 accent-brand-primary-base"
            }, props.fieldProps)), /*#__PURE__*/ React.createElement("label", {
                htmlFor: "".concat(id, "-").concat(option.value)
            }, /*#__PURE__*/ React.createElement(Body, null, option.label)));
        })), help, !!error && /*#__PURE__*/ React.createElement(ErrorMessage, {
            className: "mt-3"
        }, error));
    }
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: className
    }, /*#__PURE__*/ React.createElement(FieldLabel, {
        htmlFor: id
    }, label, required ? /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": "true"
    }, " *") : null), props.type === "input" && /*#__PURE__*/ React.createElement(Input, _extends({
        id: id,
        ref: ref,
        name: name
    }, props.fieldProps)), props.type === "textarea" && /*#__PURE__*/ React.createElement(Textarea, _extends({
        id: id,
        ref: ref,
        name: name
    }, props.fieldProps)), props.type === "select" && /*#__PURE__*/ React.createElement(Select, _extends({
        id: id,
        ref: ref,
        name: name,
        options: props.options
    }, props.fieldProps)), help, !!error && /*#__PURE__*/ React.createElement(ErrorMessage, {
        className: "mt-3"
    }, error));
}
export var FormField = /*#__PURE__*/ forwardRef(RawFormField);

//# sourceMappingURL=FormField.js.map